import types from '../mutation-types'
import { getBrandingBySlug, getBrandingByArchiveName, DEFAULT_ARCHIVE } from '../../config/branding'

const state = {
  current: getBrandingBySlug(DEFAULT_ARCHIVE)
}

const mutations = {
  [types.SET_CURRENT_BRANDING] (state, branding) {
    state.current = branding
  }
}

const actions = {
  setBrandingFromSlug ({commit}, slug) {
    commit(types.SET_CURRENT_BRANDING, getBrandingBySlug(slug))
  },
  setBrandingFromProfile ({commit}, profile) {
    var archiveName = profile && profile.archive && profile.archive.data
      ? profile.archive.data.nome : null
    commit(types.SET_CURRENT_BRANDING, getBrandingByArchiveName(archiveName))
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/branding.js